import { useDispatch, useSelector } from 'react-redux';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';
import FJHeadshotPreview from '../view/FJHeadshotPreview';
import FJImagePreviewModalContainer from '../../../FJModals/FJImagePreviewModal/FJImagePreviewModalContainer';
import { useCallback } from 'react';
import FJActionCommon from '../../../../redux/action/FJActionCommon';
import FJActionModal from '../../../../redux/action/FJActionModal';
import FJAppConstant from '../../../../constants/FJAppConstant';
import { GENERATION_CATEGORIES_OPTIONS } from '../../../../config/dataConfig/FJHeadshotGeneratorData';

function FJHeadshotPreviewContainer() {
    const dispatch = useDispatch();
    const currentCollection = useSelector(state => state.headshotGenerator.currentCollection);

    // 多选相关状态
    const selectList = useSelector(state => state.common.selectList);
    const isMultipleMode = useSelector(state => state.common.isMultipleMode);
    const tabIndex = useSelector(state => state.headshotGenerator.tabIndex);

    const handleGoBack = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.setCurrentCollectionAction(null));
        dispatch(FJActionCommon.setIsMultipleModeAction(false));
        dispatch(FJActionCommon.setSelectListAction([]));
    }, [dispatch]);

    const handleRecreate = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.changeTabIndexAction(0));
        dispatch(FJActionCommon.setIsMultipleModeAction(false));
        const category = GENERATION_CATEGORIES_OPTIONS.find(item => item.key === currentCollection?.category);
        if (category) {
            dispatch(FJActionHeadshotGenerator.setCurrentStepIndexAction(0));
            dispatch(FJActionHeadshotGenerator.setCategoryAction(category));
        }
    }, [currentCollection?.category, dispatch]);

    const handleDownload = useCallback(
        ids => {
            dispatch(FJActionHeadshotGenerator.onDownloadHeadshotAction(ids));
        },
        [dispatch],
    );

    const handleDelete = useCallback(
        (ids, callback) => {
            dispatch(
                FJActionCommon.multiDeleteAction(
                    [currentCollection.id],
                    list => {
                        const newCollection = list.find(item => item.id === currentCollection.id);
                        if (newCollection) {
                            dispatch(
                                FJActionHeadshotGenerator.setCurrentCollectionAction(
                                    list.find(item => item.id === currentCollection.id),
                                ),
                            );
                        } else {
                            dispatch(FJActionHeadshotGenerator.setCurrentCollectionAction(undefined));
                            handleGoBack?.();
                        }
                        callback?.();
                    },
                    {
                        type: FJAppConstant.HEADSHOT_GENERATOR,
                        headshotIds: ids,
                    },
                ),
            );
        },
        [currentCollection?.id, dispatch, handleGoBack],
    );

    // 多选相关函数
    const setSelectList = useCallback(
        value => {
            if (!isMultipleMode) {
                dispatch(FJActionCommon.setIsMultipleModeAction(true));
            }

            dispatch(FJActionCommon.setSelectListAction(value));
            if (value.length === 0) {
                dispatch(FJActionCommon.setIsMultipleModeAction(false));
            }
        },
        [dispatch, isMultipleMode],
    );

    const multiDelete = useCallback(
        ids => {
            dispatch(
                FJActionCommon.multiDeleteAction(
                    [currentCollection.id],
                    list => {
                        const newCollection = list.find(item => item.id === currentCollection.id);
                        if (newCollection) {
                            dispatch(
                                FJActionHeadshotGenerator.setCurrentCollectionAction(
                                    list.find(item => item.id === currentCollection.id),
                                ),
                            );
                        } else {
                            dispatch(FJActionHeadshotGenerator.setCurrentCollectionAction(undefined));
                            handleGoBack?.();
                        }
                        dispatch(FJActionCommon.setIsMultipleModeAction(false));
                        dispatch(FJActionCommon.setSelectListAction([]));
                    },
                    {
                        type: FJAppConstant.HEADSHOT_GENERATOR,
                        headshotIds: ids,
                    },
                ),
            );
        },
        [currentCollection?.id, dispatch, handleGoBack],
    );

    const clearSelected = useCallback(() => {
        dispatch(FJActionCommon.setIsMultipleModeAction(false));
    }, [dispatch]);

    const multiDownload = useCallback(
        ids => {
            dispatch(FJActionHeadshotGenerator.onDownloadHeadshotAction(ids));
        },
        [dispatch],
    );

    // 图片预览相关函数
    const handleImagePreview = useCallback(
        id => {
            if (!currentCollection?.headshotList || currentCollection.headshotList.length === 0) {
                return;
            }
            const previewList = currentCollection.headshotList?.filter(item => item.status === 'succeeded') ?? [];
            const imageIndex = previewList?.findIndex(item => item.id === id);

            dispatch(
                FJActionModal.showImagePreviewModalAction(previewList, imageIndex, {
                    showDeleteButton: true,
                    showDownloadButton: true,
                    onDelete: handleDelete,
                    onDownload: handleDownload,
                }),
            );
        },
        [currentCollection?.headshotList, dispatch, handleDelete, handleDownload],
    );

    const handleRetry = useCallback(
        (eventId, id) => {
            dispatch(FJActionHeadshotGenerator.onRetryHeadshotAction(eventId, id));
        },
        [dispatch],
    );

    return (
        <>
            <FJHeadshotPreview
                currentCollection={currentCollection}
                onGoBack={handleGoBack}
                onRecreate={handleRecreate}
                onDownload={handleDownload}
                onDelete={handleDelete}
                selectList={selectList}
                isMultipleMode={isMultipleMode}
                setSelectList={setSelectList}
                multiDelete={multiDelete}
                clearSelected={clearSelected}
                multiDownload={multiDownload}
                onImagePreview={handleImagePreview}
                onRetry={handleRetry}
                tabIndex={tabIndex}
                id={currentCollection?.id}
            />
            <FJImagePreviewModalContainer />
        </>
    );
}

export default FJHeadshotPreviewContainer;
